import { isTauri as isTauriRuntime } from "@tauri-apps/api/core";

export interface SetupInstallResult {
  writtenPaths: string[];
  destinationDirs: string[];
  sourcePath?: string | null;
}

interface SetupSourceMatch {
  path: string;
  fileName: string;
  matchedCarFolder: string;
}

interface InstallSetupArgs {
  bytes: Uint8Array;
  fileName: string;
  carName?: string | null;
  carFolderHint?: string | null;
  nestedSubdirs?: string[];
}

interface InstallSessionSetupArgs {
  carName?: string | null;
  rawSetupName: string;
  carFolderHint?: string | null;
}

export function isDesktopSetupInstallAvailable(): boolean {
  return isTauriRuntime()
    || "__TAURI_DETECTED__" in window
    || (window as any).isTauri === true
    || navigator.userAgent.includes("OSC-Desktop-Agent")
    || navigator.userAgent.includes("SimSense-Desktop");
}

export async function installSetupBytes({
  bytes,
  fileName,
  carName,
  carFolderHint,
  nestedSubdirs,
}: InstallSetupArgs): Promise<SetupInstallResult> {
  const { invoke } = await import("@tauri-apps/api/core");
  return invoke<SetupInstallResult>("install_setup_bytes", {
    bytes: Array.from(bytes),
    fileName,
    carName: carName ?? null,
    carFolderHint: carFolderHint ?? null,
    nestedSubdirs: nestedSubdirs ?? null,
  });
}

export async function installSessionSetupFromLocal({
  carName,
  rawSetupName,
  carFolderHint,
}: InstallSessionSetupArgs): Promise<SetupInstallResult> {
  const { invoke } = await import("@tauri-apps/api/core");
  const source = await invoke<SetupSourceMatch>("find_local_setup_file", {
    setupName: rawSetupName,
    carName: carName ?? null,
    carFolderHint: carFolderHint ?? null,
  });

  return invoke<SetupInstallResult>("install_setup_file", {
    sourcePath: source.path,
    fileName: source.fileName,
    carName: carName ?? null,
    carFolderHint: carFolderHint ?? null,
    nestedSubdirs: ["SimSense"],
  });
}

export function getSessionCarFolderHint(sessionMetadata: any): string | null {
  const driverInfo = sessionMetadata?.DriverInfo;
  if (!driverInfo || !Array.isArray(driverInfo.Drivers)) return null;
  const me = driverInfo.Drivers.find((driver: any) => driver?.UserID === driverInfo.DriverUserID) ?? driverInfo.Drivers[0];
  return me?.CarPath ?? me?.CarDirPath ?? me?.CarDir ?? null;
}
